<div class="content-section">
    <div class="title">Field Setting</div>
    <div class="flex tab-section">
        <div class="tab" [ngClass]="active == 'role' ? 'active': 'inactive'" (click)="activeTab('role')">Role Information
        </div>
        <div class="tab" [ngClass]="active == 'system' ? 'active': 'inactive'" (click)="activeTab('system')">System
            Parameters</div>
    </div>
    <div *ngIf="active == 'role'">
        <role-information></role-information>
    </div>
    <div *ngIf="active == 'system'">
        <system-parameters></system-parameters>
    </div>
</div>
